<app-tooltip-on-text-overflow [tooltipContent]="calculatedCellValue">
    {{ _columnOptions?.field === "created_at" ? (calculatedCellValue | dateFormat | async ) : (calculatedCellValue || '')}}
</app-tooltip-on-text-overflow>